<template>


  <v-main class="surfaceContainerLow pt-md-8">

    <!-- Mobile -->
    <v-navigation-drawer class="pt-4" v-if="$vuetify.breakpoint.smAndDown" v-model="drawer" absolute permanent
      :mini-variant.sync="mini">
      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-avatar class="primaryContainer">
            <span class="primary--text text-h5">
              {{ usuario.nombre.substr(0, 1) }}
            </span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title>{{ user.nombre }}</v-list-item-title>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider></v-divider>
      <v-list>



        <v-list-item class="item-list-menu-perfil" v-for="item in filteredItems" :key="item.title"
          @click="optionSelect(item.option)" :class="{ optionSelect: item.option == optionPerfil }">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="my-auto">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="logout" class="item-list-menu-perfil">
          <v-list-item-icon>
            <v-icon color="onSurface">mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="my-auto">Cerrar sesión</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-container class="pt-0 mt-0 surfaceContainerLow">
      <v-row class="mt-0">




        <v-col v-if="$vuetify.breakpoint.mdAndUp" md="3">
          <v-card rounded="lg" class="d-flex">


            <v-navigation-drawer v-model="drawer" permanent>
              <v-list-item class="px-2">
                <v-list-item-avatar>
                  <v-avatar class="primaryContainer"><span class="primary--text text-h5">
                      {{ usuario.nombre.substr(0, 1) }}
                    </span></v-avatar>
                </v-list-item-avatar>
                <v-list-item-title>{{ user.nombre }}</v-list-item-title>

              </v-list-item>
              <v-divider></v-divider>
              <v-list>



                <v-list-item class="item-list-menu-perfil" v-for="item in filteredItems" :key="item.title"
                  @click="optionSelect(item.option)" :class="{ optionSelect: item.option == optionPerfil }">
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="my-auto">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout" class="item-list-menu-perfil">
                  <v-list-item-icon>
                    <v-icon color="onSurface">mdi-exit-to-app</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="my-auto">Cerrar sesión</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-navigation-drawer>
          </v-card>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>
        <v-col cols="11" md="9" class=" ml-md-0">







          <v-row>




            <v-breadcrumbs :items="activeBreadcrumbs">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item class="red--text" :key="item.title" @click="optionSelect(item.option)"
                  :class="{ optionSelect: item.option == optionPerfil }" :to="item.to" :disabled="item.disabled">
                  {{ item.title.toUpperCase() }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>



          </v-row>


          <v-col class="d-flex justify-content-md-center">
            <template>
              <v-card flat class="surfaceContainerLow">
                <v-row class="d-flex flex-column  flex-md-row flex-md-nowrap">






                  <v-col>
                    <template v-if="optionPerfil === 1">
                      <v-container grid-list-md class="mx-0 px-0">
                        <v-text class="display-1">
                          <v-icon large>mdi-ticket</v-icon> Mis Boletas</v-text>

                        <hr />
                        <v-col cols="12">
                          <v-text Viewer class="headline">
                            Filtrar compras
                            en un rango de fechas.
                          </v-text>
                        </v-col>



                        <v-row class="d-flex flex-column flex-sm-row ">
                          <v-col col="12" sm="auto" md="4">
                            <v-dialog ref="dialogDesde" v-model="modalDesde" :return-value.sync="desde" width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field outlined v-model="desde" label="Desde" prepend-inner-icon="event" readonly
                                  v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="desde" scrollable locale="es-ES">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="modalDesde = false">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialogDesde.save(desde)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-col>
                          <v-col col="12" sm="auto" md="4">
                            <v-dialog ref="dialogHasta" v-model="modalHasta" :return-value.sync="hasta" width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field v-model="hasta" outlined label="Hasta" prepend-inner-icon="event" readonly
                                  v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="hasta" scrollable locale="es-ES">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="modalHasta = false">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dialogHasta.save(hasta)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-col>
                          <v-col col="12" sm="8" md="4">
                            <v-btn color="primary" block :large="$vuetify.breakpoint.smAndUp" rounded type="submit"
                              @click="searchHistorialCompras" style="top: 6px">
                              <v-icon>search</v-icon>
                              Buscar</v-btn>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row class="mx-0 px-0 ">

                          <v-col class="mx-0 px-0" v-for="item in compras" :key="item.id" cols="12">
                            <v-card outlined class="my-2 rounded-lg">


                              <article class=" d-flex justify-space-between align-center flex-nowrap mx-md-2 py-2">



                                <v-text class="px-4" text color="outline">
                                  Fecha: {{ formatFecha(item.fecha) }}
                                </v-text>

                                <v-btn large title="Detalles de la compra" text color="tertiary"
                                  @click="searchCompra(item.id)">
                                  Detalle de la Compra
                                </v-btn>
                              </article>
                              <v-divider></v-divider>
                              <!-- Card detalles escritorio -->
                              <v-row v-if="$vuetify.breakpoint.mdAndUp">
                                <!-- Imagen del evento -->
                                <v-col cols="4" md="2" class="d-flex align-center">

                                  <v-img src="/images/logo-dark.svg">

                                  </v-img>
                                </v-col>

                                <v-col class="d-flex flex-column align-items-center justify-content-md-center ">

                                  <v-card-text class="ma-0 pa-0  d-flex ">
                                    <!-- Condiciones de estado (Pendiente, Aceptada, Rechazada) -->

                                    <!-- Estado en proceso -->
                                    <v-text v-if="item.active == 0" close class="overline mx-0 my-2 success--text">
                                      <v-icon small left color="orange">
                                        access_time
                                      </v-icon>
                                      En proceso
                                    </v-text>
                                    <!-- Estado en Aprobada -->
                                    <v-text v-if="item.active == 1" close
                                      class="overline mx-0 my-2 success--text d-flex justify-center">
                                      <v-icon small left color="success">mdi-checkbox-marked-circle</v-icon>
                                      Aprobada
                                    </v-text>
                                    <!-- Estado en Rechazada -->
                                    <v-text v-if="item.active == 2" close
                                      class="overline mx-0 my-2 error--text d-flex justify-center">
                                      <v-icon small left color="error">cancel</v-icon>
                                      Rechazada
                                    </v-text>


                                  </v-card-text>
                                  <!-- Datos del Evento -->
                                  <v-card-text class="ma-0 pa-0 d-flex flex-column  flex-md-wrap"
                                    v-if="$vuetify.breakpoint.mdAndUp">



                                    <v-text class="d-inline-block title font-weight-regular">
                                      {{ item.nombre }}
                                    </v-text>


                                    <v-text class=" body-1 font-weight-regular outline--text">
                                      {{ item.fecha_evento }}
                                    </v-text>

                                  </v-card-text>
                                </v-col>
                                <!-- Botones de acción -->
                                <!-- <v-col class="d-flex flex-column align-items-end justify-content-center my-1 "
                                  v-if="$vuetify.breakpoint.mdAndUp">


                                  <v-card-actions>
                                    <v-row class="d-flex flex-column align-stretch">
                                      <v-col cols="12">
                                        <v-img contain width="180" class="my-2"
                                          src="/images/Add_to_Google_Wallet_badge.svg"></v-img>

                                      </v-col>
                                      <v-col cols="12">
                                        <v-img width="180" class="my-2"
                                          src="/images/Add_to_Apple_Wallet_badge.svg"></v-img>
                                      </v-col>


                                    </v-row>

                                  </v-card-actions>



                                </v-col> -->

                              </v-row>
                              <!-- Card detalles mobile -->
                              <v-row @click="searchCompra(item.id)" v-if="$vuetify.breakpoint.smAndDown">
                                <!-- Imagen del evento -->
                                <v-col cols="4" md="2" class="d-flex align-center">

                                  <v-img src="/images/logo-dark.svg">

                                  </v-img>
                                </v-col>

                                <v-col class="d-flex flex-column align-items-center justify-content-between ">

                                  <v-card-text class="ma-0 pa-0  d-flex ">
                                    <!-- Condiciones de estado (Pendiente, Aceptada, Rechazada) -->

                                    <!-- Estado en proceso -->
                                    <v-text v-if="item.active == 0" close class="overline mx-0 my-2 success--text">
                                      <v-icon small left color="orange">
                                        access_time
                                      </v-icon>
                                      En proceso
                                    </v-text>
                                    <!-- Estado en Aprobada -->
                                    <v-text v-if="item.active == 1" close
                                      class="overline mx-0 my-2 success--text d-flex justify-center">
                                      <v-icon small left color="success">mdi-checkbox-marked-circle</v-icon>
                                      Aprobada
                                    </v-text>
                                    <!-- Estado en Rechazada -->
                                    <v-text v-if="item.active == 2" close
                                      class="overline mx-0 my-2 error--text d-flex justify-center">
                                      <v-icon small left color="error">cancel</v-icon>
                                      Rechazada
                                    </v-text>


                                  </v-card-text>
                                  <v-card-text class="ma-0 pa-0 ">

                                    <!-- Datos del Evento -->

                                    <v-text class="d-inline-block title font-weight-regular">
                                      {{ item.nombre }}
                                    </v-text>


                                    <v-text class=" body-1 font-weight-regular outline--text">
                                      {{ item.fecha_evento }}
                                    </v-text>

                                  </v-card-text>
                                </v-col>


                              </v-row>
                              <!-- Wallets -->
                              <!--  <v-row v-if="$vuetify.breakpoint.smAndDown">
                                <v-col>
                                  <v-divider></v-divider>
                                  <v-card-actions class="d-flex  justify-content-center ">
                                    <v-row wrap>
                                      <v-col cols="12" sm="6">
                                        <v-img width="150" src="/images/Add_to_Google_Wallet_badge.svg"></v-img>

                                      </v-col>
                                      <v-col cols="12" sm="6">
                                        <v-img width="150" src="/images/Add_to_Apple_Wallet_badge.svg"></v-img>
                                      </v-col>
                                    </v-row>
                                  </v-card-actions>
                                </v-col>
                              </v-row> -->



                              <!-- Acciones como reimprimir o detalles -->
                              <v-card-actions>
                                <v-chip
                                  v-if="item.tipo_venta == 'VIRTUAL' && item.active == 1 && item.status_evento == 1 && item.se_imprime == 1 && (item.dias <= 0 && item.dias != null)"
                                  color="success" @click="ImprimirCompra(item.id)">
                                  <v-icon left>cloud_download</v-icon>
                                  Descarga aquí tus boletas
                                </v-chip>
                                <v-chip
                                  v-if="item.tipo_venta == 'VIRTUAL' && item.active == 1 && item.status_evento == 1 && item.se_imprime == 0 && item.dias >= 1"
                                  color="info">
                                  <v-icon left>info</v-icon>
                                  En {{ item.dias }} días se habilitará la descarga de boletas
                                </v-chip>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>


                        <!--  <v-data-table :headers="headers" must-sort :items="compras" :length="pages" :search="search"
                          :server-items-length="totalItemCount" class="elevation-1 table-ventas" :loading="loading"
                          :no-data-text="'No se han encontrado compras...'">
                          <template v-slot:items="props">
                            <td class="font-weight-bold">#{{ props.item.id }}</td>
                            <td class="text-xs-center">
                              {{ formatFechaHumans(props.item.fecha) }}<br /><small>{{
                                props.item.fecha
                                }}</small>
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.tipo_venta }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.pago_parcial }}
                            </td>
                            <td class="text-xs-center">{{ props.item.evento.nombre }}</td>
                            <td class="text-xs-center text-uppercase">
                              {{ props.item.forma_pago }}
                            </td>
                            <td class="text-xs-center">
                              {{ props.item.moneda.simbolo
                              }}{{ formatoMoneda(props.item.total) }} ({{
                              props.item.moneda.codigo_moneda
                              }})
                            </td>
                          </template>
                          <template v-slot:item.active="data">
                            <td class="text-xs-center">
                              <v-chip v-if="data.item.active == 0" class="ma-2" color="orange" text-color="white">
                                <v-avatar left>
                                  <v-icon>access_time</v-icon>
                                </v-avatar>
                                Pendiente
                              </v-chip>
                              <v-chip v-if="data.item.active == 1" class="ma-2" color="teal" text-color="white">
                                <v-avatar left>
                                  <v-icon>check_circle</v-icon>
                                </v-avatar>
                                Aceptada
                              </v-chip>
                              <v-chip v-if="data.item.active == 2" class="ma-2" color="error" text-color="white">
                                <v-avatar left>
                                  <v-icon>cancel</v-icon>
                                </v-avatar>
                                Rechazada
                              </v-chip>
                            </td>
                          </template>
                          <template v-slot:item.reimprimir="{ item }">

                            <v-chip title="Descargar" @click="ImprimirCompra(item.id)" style="padding: 20px;"
                              color="success"
                              v-if="item.tipo_venta == 'VIRTUAL' && item.active == 1 && item.status_evento == 1 && item.se_imprime == 1 && (item.dias <= 0 && item.dias != null)">
                              <v-icon left style="padding: 5px;">cloud_download</v-icon>
                              Descarga aquí <br> tus boletas
                            </v-chip>
                            <v-chip class="ma-3" size="x-large" style="padding: 25px;"
                              v-if="item.tipo_venta == 'VIRTUAL' && item.active == 1 && item.status_evento == 1 && item.se_imprime == 0 && item.dias >= 1">
                              <v-icon left style="padding: 5px;">info</v-icon>
                              En {{ item.dias }} días se habilitará <br>
                              la descarga de boletas
                            </v-chip>
                            <v-chip class="ma-3" size="x-large" style="padding: 25px;"
                              v-if="item.tipo_venta == 'VIRTUAL' && item.active == 1 && item.status_evento != 1">
                              <v-icon left style="padding: 5px;">block</v-icon>
                              No Disponible
                            </v-chip>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn title="Detalles de la compra" @click="searchCompra(item.id)">
                              Detalle de la compra
                            </v-btn>
                          </template>
                        </v-data-table> -->
                        <div class="text-xs-center pt-2">
                          <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
                        </div>
                      </v-container>
                    </template>
                    <template v-if="optionPerfil === 2">
                      <v-container grid-list-md>
                        <form @submit.prevent="updateProfile" autocomplete="off">
                          <v-text class="display-1">
                            <v-icon large>mdi-account</v-icon> Mi Perfil</v-text>

                          <hr />
                          <v-col cols="12">
                            <v-text Viewer class="headline">
                              Datos Personales
                            </v-text>
                          </v-col>
                          <v-row class="d-flex justify-center justify-md-start mt-4">

                            <v-col cols="12" md="8">

                              <v-text-field label="Nombre" outlined required v-model="user.nombre"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Apellidos" required v-model="user.apellidos"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-select outlined v-model="user.tipo_identificacion" item-value="id" item-text="code"
                                :items="tipoIdentificaciones" label="Tipo de identificacion " persistent-hint
                                :hint="descripcionTipoIdentificacion" required></v-select>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Numero de identificacion " required
                                v-model="user.identificacion"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Correo electronico" type="email" readonly
                                v-model="user.email"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-select outlined v-if="show_list_departamentos" v-model="user.departamento"
                                item-value="id" item-text="descripcion" :items="departamentos" label="Departamento "
                                prepend-inner-icon="location_on" persistent-hint required></v-select>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-select outlined v-if="show_list_ciudades" v-model="user.ciudad" item-value="id"
                                item-text="descripcion" :items="ciudadesSelect" label="Ciudad "
                                prepend-inner-icon="location_on" persistent-hint required
                                :disabled="user.departamento == null"
                                no-data-text="Selecciona un departamento"></v-select>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Dirección " v-model="user.direccion"
                                required></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Celular" type="tel" v-model="user.telefono"
                                autocomplete="nope"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8" class="text-left">
                              <v-btn color="primary" :block="$vuetify.breakpoint.smAndDown" rounded
                                type="submit">Actualizar mi datos</v-btn>
                            </v-col>
                          </v-row>

                        </form>
                      </v-container>
                    </template>
                    <template v-if="optionPerfil === 3">
                      <v-container grid-list-md>
                        <form @submit.prevent="updatePassword" autocomplete="off">
                          <v-text class="display-1">
                            <v-icon large>security</v-icon> Actualizar Contraseña
                          </v-text>

                          <v-divider></v-divider>
                          <v-row>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Contraseña actual " type="password" required
                                v-model="user.security.mypassword" autocomplete="nope"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Nueva Contraseña " type="password" required
                                v-model="user.security.password" autocomplete="nope"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field outlined label="Confirmar contraseña " type="password" required
                                v-model="user.security.c_password" autocomplete="off"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="8" class="text-left">
                              <v-btn color="primary" rounded type="submit"
                                :block="$vuetify.breakpoint.smAndDown">Actualizar Contraseña</v-btn>
                            </v-col>
                          </v-row>
                        </form>
                      </v-container>
                    </template>

                    <template v-if="optionPerfil === 4">

                      <article>
                        <v-btn elevation="0" fab @click.prevent="optionSelect(1)">
                          <v-icon>mdi-arrow-left</v-icon>

                        </v-btn>
                        <v-text class="title">
                          Mis Boletas
                        </v-text>
                      </article>

                      <v-divider></v-divider>
                      <v-row wrap>
                        <v-col cols="12">
                          <v-text>
                            <v-icon>info</v-icon>
                            <b class="text-underline">Detalle de compra #{{ compra.n_factura }}</b>
                          </v-text>
                        </v-col>                   
                      </v-row>
                      <br />
                      <h6><b>N° FACTURA: </b> {{ compra.n_factura }}.</h6>
                      <h6>
                        <b>FECHA: </b> {{ compra.fecha }}
                        <b>({{ formatFechaHumans(compra.fecha) }})</b>
                      </h6>
                      <h6>
                        <b>TIPO VENTA: </b>
                        <span v-if="compra.tipo_venta == 1">FISICA</span><span
                          v-if="compra.tipo_venta == 0">VIRTUAL</span>
                      </h6>
                      <h6>
                        <b>TIPO PAGO: </b>
                        <span v-if="compra.pago_parcial == 1">PARCIAL</span><span
                          v-if="compra.pago_parcial == 0">COMPLETO</span>
                      </h6>
                      <div v-if="compra.tipo_venta == 1" class="mb-8">
                        <h6 class="text-uppercase">
                          <b>FORMA PAGO: </b> {{ compra.datos_pago.formaPago }} ({{
                            compra.impuesto_venta.codigo_moneda
                          }})
                        </h6>
                        <h6 v-if="compra.datos_pago.formaPago != 'efectivo'" class="text-uppercase">
                          <b>TIPO TARJETA:</b>
                          {{ compra.datos_pago.formaPagoTarjeta }}
                        </h6>
                        <h6 v-if="compra.datos_pago.formaPago != 'efectivo'">
                          <b>MONTO TARJETA:</b>
                          {{ compra.impuesto_venta.simboloMoneda
                          }}{{ formatNumber(compra.datos_pago.montoTarjeta) }} ({{
                            compra.impuesto_venta.codigo_moneda
                          }})
                        </h6>
                        <h6 v-if="compra.datos_pago.formaPago != 'tarjeta'">
                          <b>MONTO EFECTIVO:</b>
                          {{ compra.impuesto_venta.simboloMoneda
                          }}{{ formatNumber(compra.datos_pago.montoEfectivo) }} ({{
                            compra.impuesto_venta.codigo_moneda
                          }})
                        </h6>
                        <h6 v-if="compra.datos_pago.formaPago != 'efectivo'" class="text-uppercase">
                          <b>COD. VOUCHER:</b> {{ compra.datos_pago.codeVoucher }}
                        </h6>
                        <h6>
                          <b>PUNTO DE VENTA:</b> {{ compra.punto_venta.nombre }}.
                        </h6>
                        <h6>
                          <b>DIR. PUNTO VENTA:</b>
                          {{ compra.punto_venta.direccion }}.
                        </h6>
                      </div>
                      <v-row class="my-4">
                        <v-text class="headline font-weight-bold ">
                          <v-icon>mdi-ticket</v-icon> Entrega Boletas:
                        </v-text>
                      </v-row>
                      <div class=" mt-4 pb-4">

                        <h6>
                          <b>MEDIO: </b>
                          <span v-if="compra.entrega_boletas === 'digital'">
                            ENTREGA DIGITAL
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on }">
                                <v-icon color="gray" v-on="on"> info </v-icon>
                              </template>
                              Este medio enviara tus boletas y/o palcos a tu correo
                              electronico.
                            </v-tooltip>
                          </span>
                          <span v-if="compra.entrega_boletas === 'fisica'">
                            ENTREGA FISICA
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on }">
                                <v-icon color="gray" v-on="on"> info </v-icon>
                              </template>
                              Deberas acercarte a un punto de venta autorizado del
                              evento a reclamar tus boletas y/o palcos de manera
                              impresa.
                            </v-tooltip>
                          </span>
                          <span v-if="compra.entrega_boletas === 'domicilio'">
                            ENTREGA A DOMICILIO
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on }">
                                <v-icon color="gray" v-on="on"> info </v-icon>
                              </template>
                              Tus boletas y/o palcos seran entregados a tu domicilio
                              de manera impresa.
                            </v-tooltip>
                          </span>
                          <span v-if="compra.entrega_boletas === 'taquilla'">
                            ENTREGA EN TAQUILLA
                            <v-tooltip top color="black">
                              <template v-slot:activator="{ on }">
                                <v-icon color="gray" v-on="on"> info </v-icon>
                              </template>
                              Deberas reclamar tus boletas y/o palcos en la taquilla
                              del evento.
                            </v-tooltip>
                          </span>
                        </h6>
                        <h6>
                          <b>ESTADO: </b>
                          <v-chip v-if="compra.active === '0'" class="ma-2" color="orange" text-color="white">
                            <v-avatar left>
                              <v-icon>access_time</v-icon>
                            </v-avatar>
                            Pendiente
                          </v-chip>
                          <v-chip v-if="compra.active === '1'" class="ma-2" color="teal" text-color="white">
                            <v-avatar left>
                              <v-icon>check_circle</v-icon>
                            </v-avatar>
                            Aprobada
                          </v-chip>
                          <v-chip v-if="compra.active === '2'" class="ma-2" color="error" text-color="white">
                            <v-avatar left>
                              <v-icon>cancel</v-icon>
                            </v-avatar>
                            Rechazada
                          </v-chip>
                        </h6>
                      </div>
                      <h6 class="text-secondary mt-5" v-if="compra.abonos_venta_parcial.length > 0">
                        ABONOS REALIZADOS:
                      </h6>
                      <table class="table" v-if="compra.abonos_venta_parcial.length > 0">
                        <thead>
                          <tr>
                            <th class="text-center">FORMA DE PAGO</th>
                            <th class="text-center">TIPO TARJETA</th>
                            <th class="text-center">MONTO EFECTIVO</th>
                            <th class="text-center">MONTO TARJETA</th>
                            <th class="text-center">COD VOUCHER</th>
                            <th class="text-center">FECHA</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in compra.abonos_venta_parcial">
                            <td class="text-center text-uppercase">
                              {{ item.forma_pago }}
                            </td>
                            <td class="text-center text-uppercase">
                              {{
                                item.forma_pago != "efectivo"
                                  ? item.tipo_tarjeta
                                  : ""
                              }}
                            </td>
                            <td class="text-center">
                              {{ compra.impuesto_venta.simboloMoneda
                              }}{{ formatNumber(item.monto_efectivo) }} ({{
                                compra.impuesto_venta.codigo_moneda
                              }})
                            </td>
                            <td class="text-center">
                              <span v-if="item.forma_pago != 'efectivo'">{{ compra.impuesto_venta.simboloMoneda
                              }}{{ formatNumber(item.monto_tarjeta) }} ({{
                                  compra.impuesto_venta.codigo_moneda
                                }})</span>
                            </td>
                            <td class="text-center">{{ item.code_voucher }}</td>
                            <td class="text-center">{{ item.created_at }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <h6 class="text-secondary mt-5">RESUMEN DE COMPRA:</h6>

                      <table class="table" style="overflow-x: scroll;">
                        <thead>
                          <tr>
                            <th class="text-center">DESCRIPCION</th>
                            <th class="text-center">VALOR</th>
                            <th class="text-center">CANTIDAD</th>
                            <th class="text-center">TOTAL</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in compra.productosFactura">
                            <td class="text-center">{{ item.descripcion }}</td>

                            <td class="text-center">
                              {{ compra.impuesto_venta.simboloMoneda }}
                              <span v-if="compra.datos_pago.formaPago != 'cortesia'">{{ formatNumber(item.valor)
                              }}</span><span v-else>0</span> ({{
                                  compra.impuesto_venta.codigo_moneda
                                }})
                            </td>
                            <td class="text-center">{{ item.cantidad }} un</td>
                            <td class="text-center">
                              {{ compra.impuesto_venta.simboloMoneda
                              }}<span v-if="compra.datos_pago.formaPago != 'cortesia'">{{
                                formatNumber(item.cantidad * item.valor)
                              }}</span><span v-else>0</span> ({{
                                  compra.impuesto_venta.codigo_moneda
                                }})
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <br />
                      <br />
                      <hr />
                      <div class="text-right">
                        <br />
                        <h5>
                          <b>SUB - TOTAL: {{ compra.impuesto_venta.simboloMoneda
                          }}<span v-if="compra.datos_pago.formaPago != 'cortesia'">{{
                              formatNumber(compra.subtotal)
                            }}</span><span v-else>0</span></b>
                          ({{ compra.impuesto_venta.codigo_moneda }})
                        </h5>
                        <h5>
                          <b>+{{ compra.impuesto_venta.descripcion }} ({{
                            compra.impuesto_venta.porcentaje * 100
                          }}%):
                          </b>
                          {{ compra.impuesto_venta.simboloMoneda
                          }}{{
                            formatNumber(compra.impuesto_venta.valorImpuesto)
                          }}
                          ({{ compra.impuesto_venta.codigo_moneda }})
                        </h5>
                        <hr />
                        <h5>
                          <b>TOTAL: {{ compra.impuesto_venta.simboloMoneda
                          }}<span v-if="compra.datos_pago.formaPago != 'cortesia'">{{ formatNumber(compra.total)
                            }}</span><span v-else>0</span>
                          </b>
                          ({{ compra.impuesto_venta.codigo_moneda }})
                        </h5>
                      </div>
                      <br />
                      <br />
                      <br />

                    </template>

                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-main>





</template>
<script>
import moment from "moment";
import axios from 'axios';
import { configApi } from '../api/configApi';
import { headers } from '../api/headers';
moment.locale("es");
export default {
  data() {
    return {
      drawer: true,
      mini: true,
      search: "",
      desde: null,
      hasta: null,
      modalDesde: false,
      modalHasta: false,
      headers: [
        {
          text: "N° VENTA",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "FECHA", value: "fecha", align: "center", sortable: false },
        {
          text: "TIPO VENTA",
          value: "tipo_venta",
          align: "center",
          sortable: false,
        },
        {
          text: "TIPO PAGO",
          value: "pago_parcial",
          align: "center",
          sortable: false,
        },
        {
          text: "FORMA DE PAGO",
          value: "forma_pago",
          align: "center",
          sortable: false,
        },
        { text: "Total", value: "total", align: "center", sortable: false },
        { text: "Estado", value: "active", align: "center", sortable: false },
        { text: "Descargar Boletas", value: "reimprimir", align: "center", sortable: false },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      items: [
        { title: 'Inicio', icon: '', option: 0, disabled: false, to: '/' },
        { title: "Mis boletas", icon: "mdi-ticket", option: 1, disabled: true, to: '' },
        { title: "Mi perfil", icon: "person", option: 2, disabled: true, to: '' },
        { title: "Constraseña", icon: "security", option: 3, disabled: true, to: '' },
        { title: "Detalle de Compra", icon: "", option: 4, disabled: true, to: '' },

      ],
      right: null,
      optionPerfil: 1,
      emailRules: [
        (v) => /.+@.+/.test(v) || "Direccion de correo electronico incorrecta",
      ],
      user: {
        nombre: null,
        apellidos: null,
        email: null,
        security: {
          mypassword: null,
          password: null,
          c_password: null,
        },
        identificacion: null,
        tipo_identificacion: 1,
        direccion: null,
        ciudad: null,
        departamento: null,
        telefono: null,
        id_rol: 2,
      },
      show_list_departamentos: false,
      show_list_ciudades: false,
      arrayimprimir: {
        id: null,
        email: null,
        nro: null,
      },
      cant_boleta: null,
      fecha_impresion: null,
    };
  },
  async beforeCreate() {
    document.title = "Mi perfil - TicketShop";
    this.$store.dispatch("user/listTipoIdentificaciones");
    this.$store.dispatch("departamento/listDepartamentos");
    this.$store.dispatch("ciudad/listCiudades");
    await this.$store.dispatch("user/historialCompras", {
      page: 1,
      desde: null,
      hasta: null,
    });
    var self = this;
    setTimeout(function () {
      self.show_list_departamentos = true;
    }, 500);
    setTimeout(function () {
      self.show_list_ciudades = true;
    }, 600);
  },
  watch: {
    pagination: {
      async handler() {
        this.$store.dispatch("user/historialCompras", {
          page: this.pagination.page,
          desde: this.desde,
          hasta: this.hasta,
        });
      },
      deep: true,
    },
  },
  created() {
    this.user.nombre = this.usuario.nombre;
    this.user.apellidos = this.usuario.apellidos;
    this.user.email = this.usuario.email;
    this.user.identificacion = this.usuario.identificacion;
    this.user.direccion = this.usuario.direccion;
    this.user.telefono = this.usuario.telefono;
    if (isNaN(this.usuario.ciudad)) {
      this.user.ciudad = null;
    } else {
      this.user.ciudad = parseInt(this.usuario.ciudad);
    }
    if (isNaN(this.usuario.departamento)) {
      this.user.departamento = null;
    } else {
      this.user.departamento = parseInt(this.usuario.departamento);
    }
    if (this.$route.params.optPerfil) {
      this.optionSelect(this.$route.params.optPerfil);
    }
  },
  methods: {
    optionSelect(option) {
      this.optionPerfil = option;
    },
    formatNumber(number) {
      return new Intl.NumberFormat("es-CO", {
        minimumFractionDigits: 0,
      }).format(number);
    },
    printFactura() {
      // Pass the element id here
      this.$htmlToPaper("printFactura");
    },
    formatoMoneda(valor) {
      if (valor != null && valor != "") {
        return new Intl.NumberFormat("es-CO").format(valor);
      } else {
        return 0;
      }
    },
    formatFecha(fecha) {
      if (fecha != null && fecha != "") {
        return moment(fecha).format('l');
      } else {
        return "";
      }
    },
    formatFechaHumans(fecha) {
      return moment(fecha).fromNow();
    },
    updateProfile() {
      if (
        this.user.nombre != null &&
        this.user.apellidos != null &&
        this.user.tipo_identificacion != null &&
        this.user.identificacion != null &&
        this.user.direccion != null &&
        this.user.departamento != null &&
        this.user.ciudad != null
      ) {
        this.$store.dispatch("user/updateProfile", this.user);
      } else {
        swal(
          "Error!",
          "Debe completar todos los campos obligatorios!",
          "error"
        );
      }
    },
    updatePassword() {
      if (
        this.user.security.password != null &&
        this.user.security.c_password != null &&
        this.user.security.mypassword != null
      ) {
        if (this.user.security.password === this.user.security.c_password) {
          this.$store
            .dispatch("user/updatePassword", this.user.security)
            .then(() => {
              this.user.security.mypassword = null;
              this.user.security.password = null;
              this.user.security.c_password = null;
            });
        } else {
          swal(
            "Error!",
            "La nueva contraseña no coincide con su campo de confirmacion!",
            "error"
          );
        }
      } else {
        swal(
          "Error!",
          "Debe completar todos los campos obligatorios!",
          "error"
        );
      }
    },
    searchHistorialCompras() {
      if (this.desde != null && this.hasta != null) {
        this.$store.dispatch("user/historialCompras", {
          page: 1,
          desde: this.desde,
          hasta: this.hasta,
        });
      } else {
        swal(
          "Error!",
          "Completa los campos para realizar la busqueda!",
          "error"
        );
      }
    },
    async searchCompra(id) {
      await this.$store.dispatch("user/searchCompra", id);
      this.optionPerfil = 4;
    },
    async ImprimirCompra(id) {
      this.$store.commit('changeLoader', true);
      await axios.get(`${configApi.apiUrl}buscar_detalles/${id}`, null, { headers: headers })
        .then(response => {
          this.cant_boleta = response.data.data.length
          if (response.status != 200) {
            swal("Error!", "no existe esta venta", "error");
          }
        })

      this.arrayimprimir.id = id
      this.arrayimprimir.email = this.user.email
      for (let i = 0; i < this.cant_boleta; i++) {
        this.arrayimprimir.nro = i
        const response = await axios.post(`${configApi.apiUrl}imprimirboletas`, this.arrayimprimir, { responseType: 'blob' });
        if (response.data.size > 0) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          let x = i + 1
          link.download = 'Boleta ' + x + '.pdf';
          link.click();
        } else {
          swal("Error!", "No tiene permitido imprimir esta boleta", "error");
        }

      }
      this.$store.commit('changeLoader', false);
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
  computed: {
    filteredItems() {
      return this.items.filter(item => item.title !== 'Inicio' && item.option !== 4);
    },

    activeBreadcrumbs() {
      if (this.optionPerfil === 4) {

        const inicio = this.items.find(item => item.title === 'Inicio') || { title: "Inicio", option: 0 };
        return [
          inicio,
          { title: "Mis boletas", option: 1, disabled: false, to: '#' },
          { title: "Detalle de la compra", option: 4 }
        ];
      } else {
        return this.items.filter(item => item.title === 'Inicio' || item.option === this.optionPerfil);
      }
    },

    usuario() {
      return this.$store.getters["user/dataUserLogged"];
    },
    tipoIdentificaciones() {
      return this.$store.getters["user/listTipoIdentificaciones"];
    },
    descripcionTipoIdentificacion() {
      return this.tipoIdentificaciones.filter(
        (item) => item.id === this.user.tipo_identificacion
      )[0].descripcion;
    },
    ciudades() {
      return this.$store.getters["ciudad/listCiudades"];
    },
    ciudadesSelect() {
      return this.ciudades.filter(
        (item) => item.id_departamento == this.user.departamento
      );
    },
    departamentos() {
      return this.$store.getters["departamento/listDepartamentos"];
    },
    compras() {
      return this.$store.getters["user/compras"];
    },
    compra() {
      return this.$store.getters["user/compra"];
    },
    pagination() {
      return this.$store.getters["user/paginationCompras"];
    },
    pages() {
      return this.$store.getters["user/pagesCompras"];
    },
    totalItemCount() {
      return this.$store.getters["user/totalItemCount"];
    },
    loading() {
      return this.$store.getters["user/loading"];
    },
  },
};
</script>
<style>
@media (max-width: 960px) {
  .container-perfil {
    width: calc(100vw - 3.5rem)
  }
}

.no-shadow {
  box-shadow: none !important;
}

.optionSelect {
  border-left: 2px #2196f3 solid;
}

.optionSelect a {
  font-weight: bold !important;
}

.elevation-1.table-ventas table thead {
  background-color: #cacaca;
}

.elevation-1.table-ventas table thead th {
  color: black;
  font-weight: bold;
}

.elevation-1.table-ventas table tbody td {
  color: black;
  font-size: 16px;
}

.item-list-menu-perfil {
  display: flex;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
}

.item-list-menu-perfil p {
  font-size: 0.75rem;
}

.item-list-menu-perfil:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.card-menu-dat-perfil {
  min-height: 700px;
}

@media (max-width: 768px) {
  .card-menu-dat-perfil {
    min-height: 400px;
  }
}
</style>